module.exports = "/wwwroot/img/call_to_action_button_block.png?ver=b48eb06b";